import * as VueRouter from 'vue-router';


import Home from '@/pages/Home';
// import Sample from '@/pages/SamplePage';
import Error404 from '@/pages/Error404';

const LARGEHEADER = { headerSize: 'large' };

export const routes = [
  { path: '/', name: 'Home', component: Home, meta: { headerSize: 'splash' } },
  // { path: '/sample', name: 'Sample', component: Sample },
  { path: '/:pathMatch(.*)*', name: 'Error 404', component: Error404, meta: LARGEHEADER, ignore: true },
];

export default new VueRouter.createRouter({
  mode: 'history',
  history: VueRouter.createWebHistory(),
  aveScrollPosition: true,
  base: __dirname,
  routes
});
